export const ENUM_LOCALSTORAGE = {
  autostart: "autostart",
  cameraId: "cameraId",
  devices: "devices",
  localCamera: "localCamera",
  localMicro: "localMicro",
  localResolution: "localResolution",
  lastAmount: "lastAmount",
  confirmAge: "confirmAge",
  haveAccount: "haveAccount",
  cameraPerm: "cameraPermission",
  typeModel: "typeModel",
  typeSort: "typeSort",
  shown: "shown",
  filter: "filter",
  isRestore: "isRestore",
  saveResolutions: "saveResolutions",
  isFullscreenChat: "isFullscreenChat",
  janusDebug: "janusDebug",
  devMode: "devMode",
};

export const ENUM_ELEMENT_ID = {
  chatBroadcaster: "chat-broadcaster",
  chatContent: "chat-content",
  zoomistContainer: "zoomist-container",
  zoomistWrapper: "zoomist-wrapper",
  fullScreen: "full-screen",
  chatButton: "chat-button",
};

export const ENUM_ELEMENT_NAME = {
  streamProfile: "stream-profile",
  streamMain: "stream-main",
  chatPageHeader: "chat-page-header",
  streamWindow: "chat-window",
  iosScrollContainer: "ios-scroll-container",
};

export const ENUM_TYPE_MES = {
  date: "date",
  someonesMessage: "someonesMessage",
  myMessage: "myMessage",
  modelMessage: "modelMessage",
  tipped: "tipped",
  lovense: "lovense",
  lovenseConnect: "lovenseConnect",
  vibratotion: "vibratotion",
  switched: "switched",
  system: "system",
  lovenseDisconnect: "lovenseDisconnect",
  paidChatSpend: "paidChatSpend",
  chatJoin: "chatJoin",
};

export const ENUM_CHAT_TAB = {
  free: "free",
  tips: "tips",
  lovense: "lovense",
};

export const ENUM_PAYMENT_TYPE = {
  directTransfer: "direct-transfer",
  tipsList: "tips-list",
  tipsLovense: "tips-lovense",
};

// ENUM_CHAT_MODE - режим мода для сервера
export const ENUM_CHAT_MODE = {
  paid: "paid-chat",
  view: "view-chat",
  free: "free-chat",
  private: "private-chat",
  pause: "pause-chat",
  tip: "tip-chat",
  exclusive: "exclusive-chat",
};

export const MODE_BY_TEXT = {
  [ENUM_CHAT_MODE.free]: "Free Chat",
  [ENUM_CHAT_MODE.paid]: "Group Show",
  [ENUM_CHAT_MODE.view]: "View Chat",
  [ENUM_CHAT_MODE.private]: "Private Chat",
  [ENUM_CHAT_MODE.exclusive]: "Private Exclusive",
  [ENUM_CHAT_MODE.pause]: "Pause",
};

export const textTypeByType = {
  chargeback: "chargeback",
  deposit: "Deposit",
  spend: "Spend",
  exclusive: "exclusive",
  tips: "tips",
  "package-buy": "Deposit",
  "correction-minus": "Correction minus",
  "correction-plus": "Correction-plus",
  "refund-minus": "Refund minus",
  "refund-plus": "Refund plus",
  "balance-correction": "Balance correction",
  "direct-transfer": "Tips",
  "tips-list": "Tips (List)",
  "tips-lovense": "Tips (Lovense)",
  "private-chat": "Private chat",
  "paid-chat": "Paid chat",
  "view-chat": "View chat",
  "pause-chat": "pause",
  "exclusive-chat": "Exclusive chat",
};
